import i18n from 'i18next';

export const columns = [
  {
    id: 'driverName',
    numeric: false,
    disablePadding: true,
    label: i18n.t('common.driver'),
    needSorting: true,
  },
  {
    id: 'vechileName',
    numeric: false,
    disablePadding: true,
    label: i18n.t('common.vehcile'),
    needSorting: true,
  },
  {
    id: 'count',
    numeric: true,
    disablePadding: false,
    label: i18n.t('Recorded Events'),
    needSorting: true,
  },
  {
    id: 'icon',
    numeric: true,
    disablePadding: false,
    label: '',
    needSorting: false,
  },
];
